import Closeicon from "../images/Closeicon";

const SponsoredChat = ({setSponsoredChat}) => {

  const adData = {
    title: "Secure VPN Partner",
    description: "Get 50% off for users. Stay invisible.",
    link: "https://dso.de",
    image: "dso-logo.svg" 
  };


  return (
    <div  className="chat_item sponsored" >
        <a   href={adData.link} target="_blank"  rel="noopener noreferrer">
            <div className= 'noGroup sponsor chat_item-image'>
                <img  src= "./images/Sponsors/dso-logo.svg" alt='sponsored'/>
            </div>
            <div className='chat_item-text'>
                <div className='chat_item-name_date'>
                    <p className='chat_item-name'>  </p>
                    <div className='chat_item-date_time'> <span></span></div>
                </div>
                <p className=' text lastMessage'>Wir koordinieren die Organspende in Deutschland </p>
            </div>
        </a>
        <button className='close_button' onClick={()=>setSponsoredChat(false)} ><Closeicon /></button>
    </div>
  );
};
export default SponsoredChat;